import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  padding-inline: 12px;

  @media (min-width: 768px) {
    flex-direction: row;

    button {
      width: auto;
    }
  }
`;

export const WrapperTuorList = styled.div`
  display: flex;
  margin-top: 40px;
  gap: 20px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

export const WrapperInformPassengers = styled.div`
  display: flex;
  margin-top: 40px;
  gap: 20px;
  overflow: visible;

  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

export const PhoneContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
  z-index: 10;

  &:has(.country-list:not(.hide-dropdown)) {
    margin-bottom: 310px;
  }

  .react-tel-input {
    width: 100%;
    position: relative;
    overflow: visible;
  }

  .react-tel-input .flag-dropdown {
    z-index: 1000;
  }

  .react-tel-input .country-list {
    position: absolute;
    z-index: 99999 !important;

    width: 360px !important;
    min-width: 360px !important;

    max-height: 280px;
    overflow-y: auto;
    overflow-x: hidden;

    margin-top: 4px;
    left: 0;
  }

  .react-tel-input .country-list .country {
    width: 100%;
    white-space: nowrap;
  }

  .react-tel-input .search {
    position: sticky;
    top: 0;
    z-index: 100000;
    background: #fff;
    padding: 8px;
  }

  .react-tel-input .search-box {
    width: 320px !important;
    margin: 0;
  }
`;
